import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const containerType = v.union(
  v.literal("20ft"),
  v.literal("40ft"),
  v.literal("40ft_hc"),
  v.literal("45ft_hc"),
  v.literal("custom"),
);

export const validatorContainer = v.object({
  name: v.string(),
  type: containerType,
  capacityVolumeCF: v.number(),
  capacityWeightLbs: v.number(),
  stackingFactor: v.number(),
  effectiveVolumeCF: v.number(),
  effectiveWeightLbs: v.number(),
  notes: v.optional(v.string()),
  isActive: v.boolean(),
  internalControl,
});

export const containers = defineTable(validatorContainer)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_type", ["type"])
  .index("by_is_active", ["isActive"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .index("by_company_and_type", ["internalControl.companyId", "type"]);
